import { FC, ReactNode } from "react";

import { Icon } from "../../../general";
import { Subheading } from "../../../typography";

import { IconButton } from "./IconButton";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly title: ReactNode;
  readonly titleId: string;
  readonly onClose: () => void;
}

/** Panel header with branding, title, and close control for the floating chat panel. */
export const ChatHeader: FC<Props> = ({ styles, title, titleId, onClose }) => (
  <div className={styles.ChatHeaderInner}>
    <span className={styles.ChatHeaderLogo} aria-hidden="true">
      <Icon name="message-dots" />
    </span>
    <Subheading id={titleId}>{title}</Subheading>
    <IconButton
      icon="x-close"
      label="Close chat"
      tooltip="Close"
      onClick={onClose}
      testId="chatbot-close"
    />
  </div>
);
